import { HelmetDexteel } from "@dexteel/mesf-core";
import { StraightenerInformationRetrieval } from "./components/StraightenerInformationRetrieval";

export const StraightenerInformationRetrievalPage = () => {
	return (
		<>
			<HelmetDexteel title="Straightener Information Retrieval" />
			<StraightenerInformationRetrieval />
		</>
	);
};
